import { openDB } from "idb";

const DB_NAME = "orglink-pwa";
const DB_VER = 1;

export async function getDB() {
  return openDB(DB_NAME, DB_VER, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("offline_attendance_logs")) {
        const store = db.createObjectStore("offline_attendance_logs", {
          keyPath: "client_id",
        });
        store.createIndex("sync_status", "sync_status");
      }
      if (!db.objectStoreNames.contains("events_cache")) {
        db.createObjectStore("events_cache", { keyPath: "id" });
      }
      if (!db.objectStoreNames.contains("kv")) {
        db.createObjectStore("kv");
      }
    },
  });
}

export async function queueOfflineScan(entry) {
  const db = await getDB();
  await db.put("offline_attendance_logs", { ...entry, sync_status: "pending" });
}

export async function getPendingScans() {
  const db = await getDB();
  return (await db.getAll("offline_attendance_logs")).filter(
    (r) => r.sync_status === "pending"
  );
}

export async function getAllScans() {
  const db = await getDB();
  return db.getAll("offline_attendance_logs");
}

export async function markScan(client_id, sync_status, note) {
  const db = await getDB();
  const existing = await db.get("offline_attendance_logs", client_id);
  if (!existing) return;
  existing.sync_status = sync_status;
  if (note) existing.note = note;
  await db.put("offline_attendance_logs", existing);
}

export async function clearSynced() {
  const db = await getDB();
  const all = await db.getAll("offline_attendance_logs");
  const tx = db.transaction("offline_attendance_logs", "readwrite");
  for (const r of all) {
    if (r.sync_status === "synced") await tx.store.delete(r.client_id);
  }
  await tx.done;
}

export async function cacheEvents(events) {
  const db = await getDB();
  const tx = db.transaction("events_cache", "readwrite");
  await tx.store.clear();
  for (const e of events) await tx.store.put(e);
  await tx.done;
}

export async function getCachedEvents() {
  const db = await getDB();
  return db.getAll("events_cache");
}
